/**
 * .select2
 * Remote search APIs
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

;$(function(){
     "use strict";

     $('.select2').select2({});
});



// WEBPACK FOOTER //
// ./resources/js/services/jquery/select2.js